

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard React base styles
import colors from "assets/theme/base/colors";

function BlogCategory({ color, size }) {
    return (
        <svg
            width={size}
            height={size}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 48 48">
            <g>
                <path d="M5,6v36c0,0.55,0.45,1,1,1h36c0.55,0,1-0.45,1-1V6c0-0.55-0.45-1-1-1H6C5.45,5,5,5.45,5,6z M7,7h34v34H7V7z"></path><path d="M38 9H28c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V10C39 9.45 38.55 9 38 9zM37 19h-8v-8h8V19zM10 11h14c.55 0 1-.45 1-1s-.45-1-1-1H10c-.55 0-1 .45-1 1S9.45 11 10 11zM10 14h14c.55 0 1-.45 1-1s-.45-1-1-1H10c-.55 0-1 .45-1 1S9.45 14 10 14zM10 17h14c.55 0 1-.45 1-1s-.45-1-1-1H10c-.55 0-1 .45-1 1S9.45 17 10 17zM10 20h14c.55 0 1-.45 1-1s-.45-1-1-1H10c-.55 0-1 .45-1 1S9.45 20 10 20zM10 23h14c.55 0 1-.45 1-1s-.45-1-1-1H10c-.55 0-1 .45-1 1S9.45 23 10 23zM20 27H10c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V28C21 27.45 20.55 27 20 27zM19 37h-8v-8h8V37zM38 37H24c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1S38.55 37 38 37zM38 34H24c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1S38.55 34 38 34zM38 31H24c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1S38.55 31 38 31zM38 28H24c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1S38.55 28 38 28zM38 25H24c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1S38.55 25 38 25z"></path>
            </g>
        </svg>
    );
}

// Setting default values for the props of BlogCategory
BlogCategory.defaultProps = {
    color: "dark",
    size: "16px",
};

// Typechecking props for the BlogCategory
BlogCategory.propTypes = {
    color: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "dark",
        "light",
        "white",
    ]),
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default BlogCategory;
